import { z } from "zod";
import { ImageAttachment } from "../attachment.firestore";
import { Price } from "../currency";
import { LongString, MediumLongString } from "../primitives";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const BookingOption = z.object({
    id: z.uuid(),
    title: MediumLongString,
    description: LongString.optional().nullable(),
    images: z.array(ImageAttachment).optional().nullable(),
    price: Price.optional().nullable(),
    confirmed: z.boolean().optional().nullable(),
    memberPreferred: z.boolean().optional().nullable(),
});
export type BookingOption = z.infer<typeof BookingOption>;
